import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const PLACE_HOLDER = 'form-place-holder';
const PLACE_HOLDER_HIDDEN = 'form-place-holder-hidden';

const PlaceHolder = (props) => {
	const { intl } = props;
	const placeHolderClass = props.show ? PLACE_HOLDER : PLACE_HOLDER_HIDDEN;
	// eslint-disable-next-line no-nested-ternary
	const placeHolder = props.show
		? props.text === 'Dropzone'
			? intl.formatMessage({ id: 'drop-zone' })
			: props.text
		: '';

	return (
		<div className={placeHolderClass}>
			<div>{placeHolder}</div>
		</div>
	);
};

PlaceHolder.propTypes = {
	text: PropTypes.string,
	show: PropTypes.bool
};

PlaceHolder.defaultProps = {
	text: 'Dropzone',
	show: false
};

export default injectIntl(PlaceHolder);
